import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=618e0420&scoped=true&"
import script from "./DefaultError.vue?vue&type=script&lang=js&"
export * from "./DefaultError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e0420",
  null
  
)

export default component.exports